import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { c as s, h as c } from "../../_chunks/VideoPlayerIcons.css.CABSRJZT.js";
const o = ({ size: r = 62 }) => /* @__PURE__ */ t(
  "svg",
  {
    width: r,
    height: r,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("circle", { cx: "32", cy: "32", r: "31", className: s }),
      /* @__PURE__ */ e("rect", { x: "25", y: "23", width: "4", height: "19", rx: "2", className: c }),
      /* @__PURE__ */ e("rect", { x: "35", y: "23", width: "4", height: "19", rx: "2", className: c })
    ]
  }
);
export {
  o as VideoPlayerPauseIcon
};
